"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _gridForm = require("./gridForm");

var _gridForm2 = _interopRequireDefault(_gridForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gridForm2.default;